module.exports = __webpack_public_path__ + "static/adjustable-base-2-intro-gallery-fabric-a7ae7ceaf1a0a449418dbc3b8a6011cc.mp4";